import { Component, Input } from "@angular/core";
import { SubscribingComponent } from "app/common";

@Component({
    selector: "app-group-section-alert",
    templateUrl: "./group-section-alert.component.html",
    styleUrls: ["./group-section-alert.component.scss"],
    standalone: false
})
export class GroupSectionAlertComponent extends SubscribingComponent {
  @Input() text: string;
  @Input() hardText: string;
}
